module.exports = __webpack_public_path__ + "static/media/face-with-steam-from-nose-svgrepo-com.848cdbe8.svg";